import { Flex, Form, FormInstance, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { formKeys } from '../../DonationForm/constants'
import { lang } from './lang'
import Voice from './Voice'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import { FormValues } from '@/pages/Donation/types'
import Label from '@/shared/components/Label'

type Props = {
  form: FormInstance<FormValues>
}

const DEFAULT_MAX_LENGTH = 200

export default function TextDonation({ form }: Props) {
  const intl = useIntl()
  const { config, username = '' } = useStreamerConfigContext()
  const isTTSEnabled = config?.text_donation_config?.tts_enabled
  const maxLength = config?.text_donation_config?.max_length ?? DEFAULT_MAX_LENGTH

  return (
    <Flex vertical gap={16}>
      <Flex vertical gap={4}>
        <Form.Item
          name={formKeys.message}
          label={
            <Label>
              <FormattedMessage {...lang.messageTitle} />
            </Label>
          }
        >
          <Input.TextArea
            placeholder={intl.formatMessage(lang.messagePlaceholder, { name: username })}
            maxLength={maxLength}
            showCount
            style={{ height: 120 }}
          />
        </Form.Item>
      </Flex>
      {isTTSEnabled ? <Voice form={form} /> : null}
    </Flex>
  )
}
